let csrfToken = ``;

export function setCsrfToken(value) {
  csrfToken = value;
}

export function apiFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: `same-origin`,
    headers: {
      ...(options.headers || {}),
      ...(options.method && options.method !== `GET`
        ? { "X-CSRF-Token": csrfToken }
        : {}),
    },
  });
}
